import type React from "react";
import { useTranslation } from "react-i18next";
import { getBackgroundColorClass } from "@/constants/backgroundColors";
import { getBackgroundPatternClass } from "@/constants/backgroundPatterns";
import { cn } from "@/lib/utils";
import { useViewSettingsStore } from "@/stores/viewSettings";
import Footer from "./Footer";
import Header from "./Header";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { backgroundColor, backgroundPatternType } = useViewSettingsStore();

  return (
    <div
      className={cn(
        "min-h-screen flex flex-col",
        getBackgroundColorClass(backgroundColor),
        getBackgroundPatternClass(backgroundPatternType),
      )}
    >
      {/* スキップリンク（アクセシビリティ向上） */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        {t("accessibility.skipToMain", "メインコンテンツへスキップ")}
      </a>

      {/* ヘッダー */}
      <Header />

      {/* メインコンテンツ */}
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">{children}</div>
      </main>

      {/* フッター */}
      <Footer />
    </div>
  );
};

export default Layout;
